export const getLocationState = (props: any, state: string) => {
  return (
    props.location.state &&
    props?.location?.state[state]
  );
};
